import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'
import {
  WebPreEnrollConfig,
  ConfigApi,
  Configuration,
} from '@clear-denver/tpc-openapi-typescript/build/v1/lookup'

export type ConfigContextValues = {
  refetchConfig: () => void
  config: WebPreEnrollConfig
}

const initialState: ConfigContextValues = {
  refetchConfig: () => null,
  config: null,
}

export const ConfigContext = createContext<ConfigContextValues>(initialState)

export const ConfigProvider = ({
  children,
}: Readonly<{
  children: React.ReactNode
}>) => {
  const [config, setConfig] = useState<WebPreEnrollConfig>()

  const configClient = useMemo(
    () =>
      new ConfigApi(
        new Configuration({
          basePath: process.env.NEXT_PUBLIC_LOOKUP_API_ENDPOINT,
        })
      ),
    []
  )

  const fetchConfig = useCallback(async () => {
    const preEnrollConfig = await configClient.getWebPreEnrollConfig()
    setConfig(preEnrollConfig)
  }, [configClient])

  useEffect(() => {
    fetchConfig()
  }, [fetchConfig])

  return (
    <ConfigContext.Provider value={{ config, refetchConfig: fetchConfig }}>
      {children}
    </ConfigContext.Provider>
  )
}

export const useConfigContext = () => useContext(ConfigContext)
